import { useAuthStore } from '@/stores/auth'
import { pinia as authStore } from '@/stores/auth'
const NewAuthStore = useAuthStore(authStore);

async function fetchFromBackend(endpoint, payload) {
    // console.log(`fetching ${endpoint} with payload: ${JSON.stringify(payload)}`);
    const token = await NewAuthStore.getToken();
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
    return await response.json();
}


export { fetchFromBackend };
